@for (config of data(); track config.id) {
  <acl-configurations-by-devices-list-item
    [configuration]="config"
  ></acl-configurations-by-devices-list-item>
}
